import {useCallback} from "react";
import {MathUtils} from "three";
import {useRoomConfig} from "../RoomConfigContext";
import {useConstrainedState} from "../../hooks/useConstrainedState";

export function useSeatConstraint(initValue, numRows, config)
{
    const { freeDepth } = useRoomConfig();
    const constrainDistance = useCallback(
        value => MathUtils.clamp(value, 150, freeDepth - (numRows - 1) * config.rowDepth - config.recline),
        [numRows, config, freeDepth]
    );
    return useConstrainedState(initValue, constrainDistance);
}